<template>
<el-dialog :visible.sync="dialogVisible" top="0" :before-close="closeModal" width="733px">
    <div class="px-5">
        <div class="pt-5 px-5">
            <div class="d-flex justify-content-center mb-2">
                <BuyerOrProviderWithCircle size="48" :color="getPrimaryColorHex.four"  :circleColor="getPrimaryColorHex.two" :companyType="company"/>
            </div>
            <h3 class="c-ndarkthree bold mb-2 text-center">
                O cadastro dos financiadores está em processamento
            </h3>
            <p class="c-ndarkfour regular text-center">
                Os financiadores estão sendo cadastrados no parceiro.
                Quando o  processo for concluído, você receberá uma notificação no e-mail
                <span class="bold">{{ $store.state.user.infos.email }}</span> sobre o resultado do envio.
            </p>
        </div>
    </div>    
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <Button @click="closeModal" :color="getPrimaryColor">
            Entendi!
        </Button>
    </span>
</el-dialog>
</template>

<script>
import BuyerOrProviderWithCircle from '@/components/icons/BuyerOrProviderWithCircle'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        company: {
            required: true,
            type: String
        }
    },
    components: {
        BuyerOrProviderWithCircle,
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
    },

}
</script>

<style lang="scss">
</style>
        